/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Code_PlaceholderInputs */

const en_admin_footer_badges_code_placeholder = /** @type {(inputs: Admin_Footer_Badges_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href="https://example.com" target="_blank"><img src="https://example.com/badge.svg" width=250 alt="Featured badge" /></a>`)
};

/**
* | output |
* | --- |
* | "<a href=\"https://example.com\" target=\"_blank\"><img src=\"https://example.com/badge.svg\" width=250 alt=\"Featured badge\" /></a>" |
*
* @param {Admin_Footer_Badges_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_code_placeholder = /** @type {((inputs?: Admin_Footer_Badges_Code_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Code_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_code_placeholder(inputs)
});
export { admin_footer_badges_code_placeholder as "admin.footer_badges.code_placeholder" }